"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCommentAction = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
function AddCommentAction(survey) {
    const commentCard = __1.CardHelper.newCard();
    commentCard.addItem(__1.CardHelper.create(adaptivecards_1.TextInput, {
        placeholder: survey.commentsAppeal || "Please elaborate on your choice",
        isMultiline: true,
        maxLength: __1.SurveyLimits.Comment.MaxLength,
        id: "comment",
    }));
    commentCard.addAction(__1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: "Submit comment",
        data: (0, __1.takingSubmitComment)(survey.id).toInvokeCommand(),
    }));
    return __1.CardHelper.create(adaptivecards_1.ShowCardAction, {
        card: commentCard,
        // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
        title: "Add comment",
    });
}
exports.AddCommentAction = AddCommentAction;
//# sourceMappingURL=AddCommentAction.js.map